module.exports = __webpack_public_path__ + "images/emoji/maple_leaf.f0bacd3a479cac502b26.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/maple_leaf.png
// module id = vmt6
// module chunks = 24